import ImageWithFallback from "@/components/app-ui/image-with-fallback";
import { Badge } from "@/components/shadcn/badge";
import { Button } from "@/components/shadcn/button";
import { secondsToHMS } from "@/lib/utils";
import { Videos } from "@prisma/client";
import { Clock3, Crown } from "lucide-react";

type SeriesSidebarVideoProps = {
    video: Videos;
    isCurrent: boolean;
    isLocked: boolean;
    onSelect: (video: Videos) => void;
};

export function SeriesSidebarVideo({
    video,
    isCurrent,
    isLocked,
    onSelect,
}: SeriesSidebarVideoProps) {
    return (
        <Button
            type="button"
            variant={isCurrent ? "secondary" : "ghost"}
            className="h-auto w-full items-center justify-start gap-3 px-2 py-1.5 whitespace-normal"
            onClick={() => onSelect(video)}
        >
            <span className="relative w-28 shrink-0 overflow-hidden rounded-lg">
                <ImageWithFallback
                    src={video.Vimeo_ThumbnailURL ?? ""}
                    fallback="/images/series-ph.jpg"
                    width={112}
                    height={63}
                    unoptimized
                    className="aspect-video w-full object-cover"
                    alt={`${video.Title} resmi`}
                />
                {isLocked && (
                    <span className="bg-foreground/50 absolute inset-0 flex items-center justify-center">
                        <Crown
                            className="text-primary size-8"
                            aria-hidden="true"
                        />
                        <span className="sr-only">Premium</span>
                    </span>
                )}
            </span>
            <span className="flex min-w-0 flex-1 flex-col items-start gap-1">
                <span className="line-clamp-2 text-left leading-snug font-semibold">
                    {video.Title}
                </span>
                <span className="text-muted-foreground flex flex-wrap items-center gap-2 text-xs">
                    {video.VideoLength && (
                        <span className="flex items-center gap-1">
                            <Clock3 aria-hidden="true" />
                            {secondsToHMS(video.VideoLength)}
                        </span>
                    )}
                    {isLocked && (
                        <Badge className="bg-primary/50 text-primary-foreground font-semibold uppercase">
                            Premium
                        </Badge>
                    )}
                </span>
            </span>
        </Button>
    );
}
